export default __webpack_public_path__ + "static/media/SendRequest.e4fde0ac.svg";